import { render, staticRenderFns } from "./UserRating.vue?vue&type=template&id=081032cc&scoped=true"
import script from "./UserRating.vue?vue&type=script&lang=js"
export * from "./UserRating.vue?vue&type=script&lang=js"
import style0 from "./UserRating.vue?vue&type=style&index=0&id=081032cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081032cc",
  null
  
)

export default component.exports